const StapelShowDocsinTooltip = (props: any) => {

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: props.tooltipHtmlnameList }}></div>
    </>
  );
};

export default StapelShowDocsinTooltip;